<template>
  <div class="cases">
    <div class="banner">
      <div class="banner_text">
        <h6>
          经典案例
        </h6>
        <p>在各行各业，让招聘更简单</p>
      </div>
    </div>
    <div class="content2">
      <ul>
        <li>
          <span class="left">
            <img class="logo_1" src="../../assets/img/cases/logo_1.png">
            <span class="title">
              服装/房地产/国际贸易/投资
            </span>
            <p>易招聘作为一款人事招聘管理的应用和背调工具，公司的人事部门自使用后，极大地提高了工作效率和工作质量。 </p>
            <p>
              该应用贯穿了日常工作的整个业务流程-订立招聘岗位计划、候选人简历入库、发起面试邀约、背调、发送Offer，而且可以清楚看见每位候选人目前进入了招聘的哪一状态，从而帮助我们的HT进一步规范工作流，推进招聘工作进度。
            </p>
          </span>
          <div class="gap"></div>
          <span class="right">
            <img class="content_img" src="../../assets/img/cases/content_1.png">
          </span>
        </li>
        <li>
          <span class="left">
            <img class="content_img" src="../../assets/img/cases/content_2.png">
          </span>
          <div class="gap"></div>
          <span class="right">
            <img class="logo_2" src="../../assets/img/cases/logo_2.png">
            <span class="title">
              母婴/家电3C/食品快消/平台电商
            </span>
            <p>自从用了易招聘，为公司人力管理节省了极大的开支并极大地提高了效率！易招聘轻应用能很清晰的查询到面试流程，并对人才储备也能很好的管理，比较符合我司的刚需。</p>
            <p> 可以预见，在未来的一年里，有了易招聘，招聘就有了一个大管家，公司的业务将会因他而逾增风采！</p>
          </span>
        </li>
        <li>
          <span class="left">
            <img class="logo_3" src="../../assets/img/cases/logo_3.png">
            <span class="title">
              农林牧渔/食品加工/制造业
            </span>
            <p>
              易招聘是一个使用起来非常流畅的人事软件，招聘专员可以直接看到各个招聘平台的邀约情况，招聘经理可以清晰的了解招聘进度，极大的方便了日常的工作，操作也很容易上手，学习成本很低，总的来说，还是非常适合符合我们公司的诉求。
            </p>
          </span>
          <div class="gap"></div>
          <span class="right">
            <img class="content_img" src="../../assets/img/cases/content_3.png">
          </span>
        </li>
      </ul>
    </div>
    <div class="footer_cases">
      <h6>
        与优秀企业一起进步
      </h6>
      <img src="../../assets/img/cases/cases.png">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    };
  },
  mounted: function () {
    this.$store.dispatch("first_nav_change", "7");
  },
  computed: {},
  methods: {

  }
};
</script>
<style lang="scss">
.cases {
  .banner {
    background: url('../../assets/img/cases/top.png') center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .banner .banner_text {
    text-align: center;

    h6 {
      font-size: 32px;
      font-weight: 600;
      color: #ffffff;
    }

    p {
      font-size: 15px;
      color: #ffffff;
      font-weight: 400;
      margin-top: 15px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/cases.vue